import { MouseEventHandler } from 'react';

const onClick: MouseEventHandler<HTMLAnchorElement> = e => e.stopPropagation();

export const options = {
  target: '_blank',
  rel: 'noopener noreferrer',
  onClick,
};
